'use strict';

var mirror = require('./modifiers/mirror.cjs');
var reverse = require('./modifiers/reverse.cjs');

const circIn = (p) => 1 - Math.sin(Math.acos(p));
const circOut = reverse.reverseEasing(circIn);
const circInOut = mirror.mirrorEasing(circIn);

exports.circIn = circIn;
exports.circInOut = circInOut;
exports.circOut = circOut;
//# sourceMappingURL=circ.cjs.map
